import { jQuery as $ } from 'lib/shim';

const SELECTOR = '.organism-collapsible';

class OrganismCollapsible {
	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$tabContentWrapper = this._$element.find('.tab-content-wrapper').first();

			this._prime();
		}

		return $element;
	}

	_prime() {
		this._initCollapsible();
	}

	_initCollapsible() {
		let styleResetTimer = $.schedule(1, $.noop);

		this._$tabContentWrapper.find('.tab').children('.collapse-button')
			.on('click', function () {
				let	$parent = $(this).parent(),
					$content = $(this).siblings('.content').first(),
					contentHeight = 0;

				if( !$parent.hasClass('active') ) {
					$content.css('height', 'auto');
				}

				contentHeight = $content.outerHeight();

				if( !$parent.hasClass('active') ) {
					$content.css('height','0');
				} else {
					$content.css('height', contentHeight);
				}

				$parent.addClass('collapsible-collapsing');

				$.schedule(25, function () {
					if( !$parent.hasClass('active') ) {
						$content.css('height', contentHeight);
					} else {
						$content.css('height', '0');
					}

					$parent.toggleClass('active');

					styleResetTimer = $.reschedule(styleResetTimer, 250, function () {
						$parent.removeClass('collapsible-collapsing');
						$content.css('height', '');
					});
				});
			})
		;
	}
}

export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismCollapsible(app, $this));
	});

	return $elements;
}
